import React, {useState, useRef, useEffect} from 'react';
import {Form, Button} from 'reactstrap';
import styles from './VerifyOTP.module.scss';

/**
 * VerifyOTP - Screen for entering and verifying OTP code
 */
function VerifyOTP({email, onOTPVerified, onBackToRequest}) {
    const [otp, setOtp] = useState(['', '', '', '', '', '', '', '']);
    const [error, setError] = useState('');
    const inputRefs = useRef([]);

    useEffect(() => {
        // Focus first input on mount
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    const handleChange = (index, value) => {
        // Only allow digits
        if (value && !/^\d$/.test(value)) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        setError('');

        // Auto-focus next input
        if (value && index < 7) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text/plain').trim();

        // Only process if it's 8 digits
        if (/^\d{8}$/.test(pastedData)) {
            const newOtp = pastedData.split('');
            setOtp(newOtp);
            setError('');
            // Focus last input
            inputRefs.current[7]?.focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const otpString = otp.join('');

        if (otpString.length !== 8) {
            setError('Bitte geben Sie den vollständigen 8-stelligen Code ein.');
            return;
        }

        setError('');
        onOTPVerified(otpString);
    };

    const handleResendCode = (e) => {
        e.preventDefault();
        console.log('[FAKE AUTH] Resending OTP to:', email);
        setOtp(['', '', '', '', '', '', '', '']);
        setError('');
        inputRefs.current[0]?.focus();
    };

    return (
        <div>
            <div className="text-center mb-4">
                <p>
                    Ein Authentifizierungscode wurde an Ihre <strong>E-Mail-Adresse</strong> verschickt.<br/>
                    Bitte geben Sie den <strong>8-stelligen Code</strong> zur Bestätigung ein.
                </p>
            </div>

            <Form onSubmit={handleSubmit}>
                <div className={styles.otpInputGroup} onPaste={handlePaste}>
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            ref={(el) => (inputRefs.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleChange(index, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            className={`${styles.otpInput} ${error ? styles.error : ''}`}
                            aria-label={`Ziffer ${index + 1} von 8`}
                        />
                    ))}
                </div>

                {error && (
                    <div className="alert alert-danger text-center small mt-3 mb-0">
                        {error}
                    </div>
                )}

                <div className="d-flex flex-column align-items-center gap-3 mt-4">
                    <Button
                        type="submit"
                        color="primary"
                    >
                        Bestätigen
                    </Button>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleResendCode}
                    >
                        Code erneut senden
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={onBackToRequest}
                    >
                        Zurück zur Email-Eingabe
                    </button>
                </div>
            </Form>
        </div>
    );
}

export default VerifyOTP;
